import React from 'react';

const PhotoGuidelines = ({ onConfirm }) => {
  return (
    <div className="flex flex-col items-center text-center p-6 bg-white rounded-lg shadow-md max-w-lg mx-auto">
      <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4">
        Capture the Perfect Pose
      </h2>
      <p className="text-gray-600 mb-6">
        For the best fit, please take a photo following these guidelines:
      </p>

      <ul className="list-disc list-inside text-left text-gray-700 mb-6">
        <li>Stand in a well-lit area.</li>
        <li>Position your body straight and facing the camera.</li>
        <li>Keep your arms relaxed at your sides.</li>
        <li>Wear form-fitting clothes for accurate measurements.</li>
      </ul>

      <div className="w-full flex justify-center mb-6">
        {/* Placeholder for a sample pose image */}
        <div className="bg-gray-200 w-48 h-64 rounded-lg flex items-center justify-center">
          <span className="text-gray-500 text-sm">Sample Pose Image</span>
        </div>
      </div>
      
      <button 
        onClick={onConfirm}
        className="bg-black text-white px-8 py-3 rounded-full text-lg font-semibold hover:bg-gray-800 transition-colors duration-200"
      >
        I Understand
      </button>
    </div>
  );
};

export default PhotoGuidelines;